export const changePageMeta = (route, from, next) => {
  return;
 /*  if(route.meta.title) {
    document.title = route.meta.title;
  } */
}